import { SrfVideoTeaser } from '@aron/landingpage/js/SrfVideoTeaser.js';
import { init as IFrameAdjustInit } from '@aron/common/srf-iframe-adjust.js';
import { init as IframeModalInit } from '@aron/common/srf-iframe-modal.js';

export const VIDEO_TEASER_SELECTOR = '.js-video-teaser';

export function init() {
  initVideoTeasers();
  IFrameAdjustInit();
  IframeModalInit();
}

function initVideoTeasers() {
  $(VIDEO_TEASER_SELECTOR)
    .filter((_, element) => !$(element).data('video-teaser-initialized'))
    .each((_, element) => {
      new SrfVideoTeaser(element);
      // mark element, so that it won't be initialized again by this module
      $(element).data('video-teaser-initialized', true);
    });
}

/**
 * This function exposes a global function to be used with ab-testing
 * It adds a video to the teaser with the given urn if the teaser is visible and removes it afterwards
 * can be called as such:
 * window.addVideoToTeaser(
 *   'urn:srf:epgEpisode:12357295',
 *   'https://srf.rokka.io/dynamic/noop/c30fc9ff8ed75b092d754bf9023a1be6c9e8915b.mp4',
 *   (urn) => console.log('Great success!', urn),
 *   (urn) => console.log('That did not work:', urn)
 * );
 */
window.addVideoToTeaser = function (
  urn,
  videoUrl,
  successCallback = () => {},
  failureCallback = () => {},
) {
  if (!urn || !videoUrl) {
    return;
  }

  const createVideoElement = (src) => {
    const element = document.createElement('video');
    element.setAttribute('loop', '');
    element.setAttribute('muted', 'true');
    element.setAttribute('autoplay', '');
    element.setAttribute('playsinline', '1');
    element.setAttribute('src', src);
    element.setAttribute(
      'style',
      'position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; object-fit: cover; transition: opacity 0.3s ease-in-out 0s; pointer-events: none; background-color: black; opacity: 0;',
    );
    element.defaultMuted = true;
    element.muted = true;
    element.classList.add('js-animated-teaser');
    return element;
  };

  const targets = document.querySelectorAll(`.js-teaser-ng[data-urn="${urn}"]`);

  targets.forEach((element) => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const videoElement = createVideoElement(videoUrl);

          if (entry.target.matches('.teaser-ng--longform')) {
            entry.target.style.position = 'relative';
            entry.target.prepend(videoElement);
          } else {
            const picture = entry.target.querySelector('picture');
            picture.style.position = 'relative';
            picture.append(videoElement);
          }

          videoElement.addEventListener(
            'playing',
            (e) => {
              e.target.style.opacity = 1;
              successCallback(urn);
            },
            { once: true },
          );
          videoElement.play().catch(() => failureCallback(urn));
        } else {
          const videoElement = entry.target.querySelector(
            '.js-animated-teaser',
          );
          if (videoElement) {
            videoElement.remove();
          }
        }
      });
    });

    observer.observe(element);
  });
};
